/** The hostnames Ghost has used for our blog */
const blogHostnames = ['hoa-express-blog.ghost.io', 'blog.hoa-express.com'];


/** Points links to other areas of our blog (e.g., articles, tags) at their company website equivalents */
export default function correctBlogLinks(element: HTMLElement) {
	// Iterate through every link
	for (const link of element.querySelectorAll('a[href]')) {
		// Parse the link's absolute URL
		let url: URL;
		
		try {
			url = new URL(link.getAttribute('href') ?? '');
		} catch {
			continue;
		}
		
		
		// Skip links that don't point to our blog
		if (!blogHostnames.includes(url.hostname)) {
			continue;
		}
		
		
		// Point the link at the same path under the company website's blog, without Ghost's trailing slash
		const path = url.pathname.replace(/\/+$/, '');
		link.setAttribute('href', `/blog${path}${url.search}${url.hash}`);
	}
}
